import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from './SignLanguageViewer.messages';
import styles from './SignLanguageViewer.module.css';

const propTypes = {
  poseBlobUrl: PropTypes.string,
  loading: PropTypes.bool,
  error: PropTypes.string,
  isFallback: PropTypes.bool,
  onClose: PropTypes.func.isRequired
};

function SignLanguageViewer({ poseBlobUrl, loading, error, isFallback, onClose, intl }) {
  useEffect(() => {
    return () => {
      if (poseBlobUrl) {
        URL.revokeObjectURL(poseBlobUrl);
      }
    };
  }, [poseBlobUrl]);

  return (
    <div className={`${styles.container} ${isFallback ? styles.fallback : ''}`}>
      <div className={styles.header}>
        <span className={styles.title}>
          <FormattedMessage {...messages.signLanguageTitle} />
        </span>
        <IconButton
          className={styles.closeButton}
          onClick={onClose}
          size="small"
          aria-label={intl.formatMessage(messages.closeViewer)}
        >
          <CloseIcon />
        </IconButton>
      </div>
      <div className={styles.content}>
        {loading && (
          <div className={styles.loadingContainer}>
            <CircularProgress size={48} />
            <p className={styles.loadingText}>
              <FormattedMessage {...messages.generatingAnimation} />
            </p>
          </div>
        )}
        {error && (
          <div className={styles.errorContainer}>
            <p className={styles.errorText}>{error}</p>
          </div>
        )}
        {poseBlobUrl && !loading && !error && (
          <pose-viewer
            src={poseBlobUrl}
            loop="true"
            background="#1a1a2e"
            class={styles.poseViewer}
          />
        )}
      </div>
    </div>
  );
}

SignLanguageViewer.propTypes = propTypes;

export default injectIntl(SignLanguageViewer);
